/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { UserData } from '../../interfaces/common/users';
// import { UsersService } from './services/users.service';
// import { UsersApi } from './api/users.api';
import { HttpService } from './api/http.service';
// import { CountryData } from '../../interfaces/common/countries';
// import { CountriesService } from './services/countries.service';
// import { CountriesApi } from './api/countries.api';
// import { SettingsApi } from './api/settings.api';
import { NbAuthModule } from '@nebular/auth';
// import { SettingsData } from '../../interfaces/common/settings';
// import { SettingsService } from './services/settings.service';

import { FacilityData } from '../../interfaces/solar/facilities';
import { FacilitiesService } from './services/facilities.service';
import { FacilitiesApi } from './api/facilities.api';
import { MeteostationsData } from '../../interfaces/solar/meteostations';
import { MeteostationsService } from './services/meteostations.service';
import { MeteostationsApi } from './api/meteostations.api';
import { InvertersData } from '../../interfaces/solar/inverters';
import { InvertersService } from './services/inverters.service';
import { InvertersApi } from './api/inverters.api';
import { CountersData } from '../../interfaces/solar/counters';
import { CountersService } from './services/counters.service';
import { CountersApi } from './api/counters.api';
import { AutomationData } from '../../interfaces/solar/automation';
import { AutomationService } from './services/automation.service';
import { AutomationApi } from './api/automation.api';


const API = [/*UsersApi,*/ FacilitiesApi, MeteostationsApi, InvertersApi, CountersApi, AutomationApi, HttpService];

const SERVICES = [
  // { provide: UserData, useClass: UsersService },
  { provide: FacilityData, useClass: FacilitiesService },
  { provide: MeteostationsData, useClass: MeteostationsService },
  { provide: InvertersData, useClass: InvertersService },
  { provide: CountersData, useClass: CountersService },
  { provide: AutomationData, useClass: AutomationService },
];

@NgModule({
  imports: [CommonModule, NbAuthModule],
})
export class SolarBackendModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: SolarBackendModule,
      providers: [
        ...API,
        ...SERVICES,
      ],
    };
  }
}
